"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generatePayload;
var _utils = require("../../middleware/utils");
var _CalculateRetirementTaxRate = _interopRequireDefault(require("./CalculateRetirementTaxRate"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function generatePayload(values) {
  var payload = {};
  var {
    lastYearTaxRate,
    retTaxRate
  } = values;

  /* istanbul ignore next */
  function setFieldIfExists(fieldName, value, forcedValue) {
    if (value !== '' && value !== undefined) {
      payload[fieldName] = value;
    } else if (forcedValue || forcedValue === 0) {
      payload[fieldName] = forcedValue;
    }
  }
  var employerMatchMap = {
    matches: 'True',
    "doesn't match": 'False'
  };
  var filingStatusMap = {
    single: 'Single',
    married: 'Married'
  };
  var planTypeMap = {
    traditional: 'Traditional',
    roth: 'Roth'
  };

  /* Start all REQUIRED general fields: 
    annualRaise, currentAge, currentContribution, employerMatchLimit, employerMatchRate, employerMatchYN, 
    filingStatus, planType, rateOfReturn, retAge, retTaxRate, salary, state, withdrawalAge
    */

  setFieldIfExists('annualRaise', 2); // user doesn't enter this in the 1st go. This only shows up in the edit modal w/ a default of 2%. Hard-code for now
  setFieldIfExists('currentAge', values.currentAge);
  setFieldIfExists('currentContribution', values.currentContribution);
  setFieldIfExists('employerMatchLimit', values.employerMatchLimit ? values.employerMatchLimit : 0);
  setFieldIfExists('employerMatchRate', values.employerMatchRate ? values.employerMatchRate : 0);
  setFieldIfExists('employerMatchYN', employerMatchMap[values.employerMatchYN]);
  setFieldIfExists('filingStatus', filingStatusMap[values.filingStatus]);
  setFieldIfExists('planType', planTypeMap[values.planType]);
  setFieldIfExists('rateOfReturn', 6); // - user doesn't enter this in on 1st go. This only shows up in the edit modal w/ a default of 6% - Hardcode for now
  setFieldIfExists('retAge', values.retAge);
  setFieldIfExists('retTaxRate', (0, _CalculateRetirementTaxRate.default)(lastYearTaxRate, retTaxRate));
  setFieldIfExists('salary', (0, _utils.parseCurrencyString)(null, values.salary));
  // Convert District Of Columbio to Washington, D.C. else use as is
  setFieldIfExists('state', values.state === 'District of Columbia' ? 'Washington, D.C.' : values.state);
  setFieldIfExists('withdrawalAge', values.withdrawalAge);
  return payload;
}